<template>
  <div>
    <table class="table is-bordered is-fullwidth">
      <tr>
        <th></th>
        <th class="has-text-centered" colspan="2">BCA</th>
        <th class="has-text-centered" colspan="2">MayBank</th>
        <th></th>
      </tr>
      <tr>
        <th></th>
        <th class="has-text-centered">Debit</th>
        <th class="has-text-centered">Credit</th>
        <th class="has-text-centered">Debit</th>
        <th class="has-text-centered">Credit</th>
        <th class="has-text-centered">Total</th>
      </tr>
      <tr v-for="(data_row, index) in data" :key="index">
        <td v-for="(data_detail, index_detail) in data_row" :key="index_detail" :class="{'content-bold': data_detail.bold === 1, 'cell-grey': data_detail.color === 'grey', 'cell-green': data_detail.color === 'green'}" v-text="data_detail.total"></td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  data () {
    return {
      header_data: [],
      selected_service: '',
      selected_counter: '',
      data: [],
      event_bus_error_detected: '',
      button_enable: 1
    }
  },
  created () {
    this.selected_service = this.getSessionItem('selected_service')
    this.selected_counter = this.getSessionItem('selected_counter')
    this.getReport()
  },
  mounted () {
    this.event_bus_error_detected = this.$geb.getFilteredBus({id: 'error_detected'}).subscribe(eventData => {
      this.button_enable = 0
    })
  },
  methods: {
    getReport () {
      var self = this
      self.$geb.emit({id: 'preloader', eventData: true})
      self.flyPostSession('report/my_giving', {
        service: this.selected_service,
        counter: this.selected_counter
      })
      .then(function (response) {
        self.$geb.emit({id: 'preloader', eventData: false})
        if (response.data.response_code === 1) {
          self.header_data = response.data.data.header_data
          self.data = response.data.data.data
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      })
      .catch(function (response) {
        self.errorMessage(response)
      })
    }
  },
  beforeDestroy () {
    if (this.event_bus_error_detected) {
      this.event_bus_error_detected.unsubscribe()
    }
  }
}
</script>

<style lang="scss" scoped>
  .content-bold {
    font-weight: bold;
  }

  .cell-grey {
    background-color: grey;
  }

  .cell-green {
    background-color: lightgreen;
  }
</style>


// WEBPACK FOOTER //
// src/pages/panel/frontdesk/report/Counter.vue